import { useProjectionsStore } from '../../stores/projections'
import { useMenuStore } from '../../stores/menuStore'

export const QUICK_COMMANDS = [
  {
    id: 'auto-projection',
    title: 'Open auto projection',
    hint: 'Projections Profiles popup',
    keywords: ['auto', 'automatic', 'projection', 'projections', 'profiles', 'pregame'],
    action: 'openAutoProjection',
    featured: true
  },
  {
    id: 'open-roster',
    title: 'Open roster',
    hint: 'Games sidebar — Rosters tab',
    keywords: ['roster', 'rosters', 'lineup', 'squad'],
    action: 'openRoster',
    featured: true
  },
  {
    id: 'create-team',
    title: 'Create team',
    hint: 'Games sidebar — add a new team',
    keywords: ['create team', 'new team', 'add team', 'team'],
    action: 'createTeam',
    featured: true
  },
  {
    id: 'create-fixture',
    title: 'Create fixture',
    hint: 'Leagues → Fixtures overlay',
    keywords: ['create fixture', 'new fixture', 'add fixture', 'new game'],
    action: 'createFixture',
    featured: true
  },
  {
    id: 'open-fixtures',
    title: 'Open fixtures',
    hint: 'Basketball fixtures list',
    keywords: ['fixtures', 'games', 'basketball', 'schedule'],
    to: '/games/fixtures',
    featured: true
  },
  {
    id: 'open-players',
    title: 'Open players',
    hint: 'Players directory',
    keywords: ['players', 'player', 'athlete'],
    to: '/games/players',
    featured: true
  },
  {
    id: 'open-outrights',
    title: 'Open outrights',
    hint: 'Outright markets',
    keywords: ['outright', 'outrights', 'futures'],
    to: '/outrights',
    featured: false
  },
  {
    id: 'open-clients',
    title: 'Open clients',
    hint: 'Client accounts',
    keywords: ['clients', 'client'],
    to: '/clients',
    featured: false
  },
  {
    id: 'open-traders',
    title: 'Open traders',
    hint: 'Trader accounts',
    keywords: ['traders', 'trader'],
    to: '/traders',
    featured: false
  },
  {
    id: 'open-invoices',
    title: 'Open invoices',
    hint: 'Billing invoices',
    keywords: ['invoices', 'billing', 'invoice'],
    to: '/invoices',
    featured: false
  },
  {
    id: 'open-analytics',
    title: 'Open analytics',
    hint: 'Analytics dashboard',
    keywords: ['analytics', 'reports', 'stats'],
    to: '/analytics',
    featured: false
  },
  {
    id: 'open-monitoring',
    title: 'Open monitoring',
    hint: 'Arbitrage monitoring',
    keywords: ['monitoring', 'arbitrage', 'alerts'],
    to: '/monitoring',
    featured: false
  },
  {
    id: 'open-settings',
    title: 'Open settings',
    hint: 'Account and app settings',
    keywords: ['settings', 'preferences', 'profile'],
    to: '/settings',
    featured: false
  },
  {
    id: 'open-boxscores',
    title: 'Open boxscores management',
    hint: 'Settings — boxscores',
    keywords: ['boxscore', 'boxscores', 'scores'],
    to: '/settings/boxscores-management',
    featured: false
  },
  // Messageboard is not public yet
  // {
  //   id: 'open-messageboard',
  //   title: 'Open messageboard',
  //   hint: 'Internal messages',
  //   keywords: ['messageboard', 'messages', 'chat'],
  //   to: '/messageboard',
  //   featured: false
  // },
  {
    id: 'open-tutorials',
    title: 'Open tutorials',
    hint: 'Getting started',
    keywords: ['tutorials', 'help', 'docs', 'guide'],
    to: '/tutorials',
    featured: false
  }
]

export function isCommandQuery(query) {
  return query.trim().startsWith('>')
}

export function getCommandQuery(query) {
  const trimmed = query.trim()
  return isCommandQuery(trimmed) ? trimmed.slice(1).trim() : trimmed
}

export function matchQuickCommands(query) {
  const q = getCommandQuery(query).toLowerCase()
  if (!q) {
    return isCommandQuery(query) ? QUICK_COMMANDS : QUICK_COMMANDS.filter(cmd => cmd.featured)
  }

  return QUICK_COMMANDS.filter((cmd) => {
    if (cmd.title.toLowerCase().includes(q)) return true
    if (cmd.hint.toLowerCase().includes(q)) return true
    return cmd.keywords.some(keyword => keyword.toLowerCase().includes(q) || q.includes(keyword.toLowerCase()))
  })
}

export function runQuickCommand(command, router) {
  if (!command) return

  const projectionsStore = useProjectionsStore()
  const menuStore = useMenuStore()

  switch (command.action) {
    case 'openAutoProjection':
      projectionsStore.autoProjectionPopup = true
      return
    case 'openRoster':
      menuStore.openRostersPanel()
      if (!router.currentRoute.value.path.startsWith('/games')) {
        router.push('/games/fixtures')
      }
      return
    case 'createTeam':
      menuStore.openCreateTeamForm()
      if (!router.currentRoute.value.path.startsWith('/games')) {
        router.push('/games/fixtures')
      }
      return
    case 'createFixture':
      menuStore.openCreateFixtureOverlay()
      return
    default:
      if (command.to) {
        router.push(command.to)
      }
  }
}
